import ForgotPassword from "@/pages/Auth/ForgotPassword";
import Login from "@/pages/Auth/Login";
import ResetPassword from "@/pages/Auth/ResetPassword";
import Apps from "@/pages/Apps";
import CompanyList from "@/pages/CompanyList";
import RedirectToApps from "@/components/RedirectToApp/redirectToApp";
import { paths, IRoute } from "@router";

import ClientCompanyProfile from "@/pages/CompanyProfile";
import ClientCompanyDetails from "@/pages/CompanyProfile/CompanyDetails";
import ClientBusinessUnits from "@/pages/CompanyProfile/BusinessUnits";
import ClientRegions from "@/pages/CompanyProfile/Regions";
import CompanyUsers from "@/pages/CompanyUsers";
import CompanyUser from "@/pages/CompanyUsers/CompanyUser";
import CreateCompanyUser from "@/pages/CompanyUsers/CreateCompanyUser";
import ClientCreateCompany from "@/pages/CreateCompany";

import AdminCompanyProfile from "@/pages/admin/CompanyProfile";
import AdminCompanyDetails from "@/pages/admin/CompanyProfile/CompanyDetails";
import AdminBusinessUnits from "@/pages/admin/CompanyProfile/BusinessUnits";
import AdminRegions from "@/pages/admin/CompanyProfile/Regions";
import AdminCreateCompany from "@/pages/admin/CreateCompany";

import GradeMapTable from "@pages/admin/GradeMapTable";
import CompanyFunctionsMapTable from "@pages/admin/CompanyFunctionsMapTable";
import AddGradeCompany from "@pages/admin/GradeMapTable/AddGradeCompany";
import JobFunction from "@pages/admin/JobFunction";
import CompanyJobFunction from "@pages/admin/CompanyJobFunction";
import SubJobFunction from "@pages/admin/JobFunction/SubJobFunction";
import CompanySubJobFunction from "@pages/admin/CompanyJobFunction/SubJobFunction";
import Sectors from "@pages/admin/Sectors";
import Industry from "@pages/admin/Sectors/Industry";
import SubIndustry from "@pages/admin/Sectors/SubIndustry";
import SubAdminsCreate from "@pages/admin/User/SubAdmins/SubAdminsCreate";
import SubAdminsEdit from "@pages/admin/User/SubAdmins/SubAdminEdit";
import SubAdminsList from "@pages/admin/User/SubAdmins/SubAdminsList";

export const routeConfig: IRoute[] = [
  {
    path: paths.ssoRoute.auth.login,
    component: Login,
    key: "Login",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.auth.forgot_password,
    component: ForgotPassword,
    key: "Forgot Password",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.auth.reset_password,
    component: ResetPassword,
    key: "Reset Password",
    isPrivate: false,
  },
];

export const admin_routeConfig: IRoute[] = [
  {
    path: paths.ssoRoute.auth.login,
    component: Login,
    key: "Login",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.auth.forgot_password,
    component: ForgotPassword,
    key: "Forgot Password",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.auth.reset_password,
    component: ResetPassword,
    key: "Reset Password",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.apps.apps,
    component: Apps,
    key: "Apps",
    isPrivate: true,
  },
  {
    path: paths.ssoRoute.company.select_company,
    component: CompanyList,
    key: "Select Company",
    isPrivate: true,
  },
  {
    path: paths.admin.users.company_users.company_user,
    component: CompanyUser,
    key: "CompanyUser",
    exact: true,
    // breadcrumb: "Users / Sub-Admins",
    isPrivate: true,
  },
  {
    path: paths.admin.users.company_users.listing,
    component: CompanyUsers,
    key: "CompanyUsersList",
    exact: true,
    // breadcrumb: "Users / Sub-Admins",
    isPrivate: true,
  },
  {
    path: paths.admin.users.company_users.create,
    component: CreateCompanyUser,
    key: "CompanyUserCreate",
    exact: true,
    breadcrumb: " Create Company User",
    isPrivate: true,
  },
  {
    path: paths.admin.users.company_users.edit,
    component: CreateCompanyUser,
    key: "CompanyUserEdit",
    exact: true,
    breadcrumb: " Create Company User",
    isPrivate: true,
  },
  {
    path: paths.admin.users.companies.create,
    component: AdminCreateCompany,
    key: "Create New Company",
    exact: true,
    breadcrumb: "Users / Companies list / Create new company",
    isPrivate: true,
    isCompany: true,
  },

  {
    path: paths.admin.users.companies.edit,
    component: AdminCreateCompany,
    key: "Edit Company",
    exact: true,
    breadcrumb: "Users / Company Details / Create company",
    isPrivate: true,
    isCompany: true,
  },
  {
    path: paths.admin.users.companies.listing,
    component: AdminCompanyProfile,
    key: "Companies Details",
    breadcrumb: "Users /  Company details",
    isPrivate: true,
    isCompany: true,
    routes: [
      {
        path: paths.admin.users.companies.profile.details,
        component: AdminCompanyDetails,
        key: "Companies Details",
        exact: true,
        breadcrumb: "Users /  Company details",
        isPrivate: true,
        isCompany: true,
      },
      {
        path: paths.admin.users.companies.profile.business_units.listing,
        component: AdminBusinessUnits,
        key: "Business Units",
        exact: true,
        breadcrumb: "Users / Business Units",
        isPrivate: true,
      },
      {
        path: paths.admin.users.companies.profile.regions,
        component: AdminRegions,
        key: "Regions",
        exact: true,
        breadcrumb: "Users / Regions",
        isPrivate: true,
        isCompany: true,
      },
    ],
  },
  {
    path: paths.admin.users.companies.profile.business_units.listing,
    component: AdminBusinessUnits,
    key: "Business Units",
    exact: true,
    breadcrumb: "Users / Business Units",
    isPrivate: true,
  },
  {
    path: paths.admin.users.companies.profile.regions,
    component: AdminRegions,
    key: "Regions",
    exact: true,
    breadcrumb: "Users / Regions",
    isPrivate: true,
  },

  // Settings → TOM Users
  {
    path: paths.admin.settings.tom_users.listing,
    component: SubAdminsList,
    key: "TOMUsersList",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.tom_users.create,
    component: SubAdminsCreate,
    key: "TOMUsersCreate",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.tom_users.edit,
    component: SubAdminsEdit,
    key: "TOMUsersEdit",
    exact: true,
    isPrivate: false,
  },

  // Settings → Sectors
  {
    path: paths.admin.settings.sectors.listing,
    component: Sectors,
    key: "Sectors",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.sectors.industry,
    component: Industry,
    key: "Industry",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.sectors.sub_industry,
    component: SubIndustry,
    key: "SubIndustry",
    exact: true,
    isPrivate: false,
  },

  // Settings → Job Functions
  {
    path: paths.admin.settings.job_function.listing,
    component: JobFunction,
    key: "JobFunctions",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.job_function.sub_job_function,
    component: SubJobFunction,
    key: "SubJobFunctions",
    exact: true,
    isPrivate: false,
  },

  // Settings → Grade Map Table
  {
    path: paths.admin.settings.grade_map_table.listing,
    component: GradeMapTable,
    key: "GradeMapTable",
    exact: true,
    isPrivate: true,
  },
  {
    path: paths.admin.settings.grade_map_table.create_grade_company,
    component: AddGradeCompany,
    key: "CreateGradeCompany",
    exact: true,
    isPrivate: true,
  },
  {
    path: paths.admin.settings.grade_map_table.edit_grade_company,
    component: AddGradeCompany, // Assuming Add & Edit share the same component
    key: "EditGradeCompany",
    exact: true,
    isPrivate: false,
  },

  // JF Work

  {
    path: paths.admin.settings.company_job_function.listing,
    component: CompanyJobFunction,
    key: "CompanyJobFunctions",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.company_job_function.company_sub_job_function,
    component: CompanySubJobFunction,
    key: "CompanySubJobFunctions",
    exact: true,
    isPrivate: false,
  },
  {
    path: paths.admin.settings.company_functions_map_table.listing,
    component: CompanyFunctionsMapTable,
    key: "CompanyFunctionsMapTable",
    exact: true,
    isPrivate: true,
  },

  {
    path: "/",
    component: RedirectToApps,
    key: "Login",
    isPrivate: false,
  },
];

export const client_routeConfig: IRoute[] = [
  {
    path: paths.ssoRoute.auth.login,
    component: Login,
    key: "Login",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.auth.forgot_password,
    component: ForgotPassword,
    key: "Forgot Password",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.auth.reset_password,
    component: ResetPassword,
    key: "Reset Password",
    isPrivate: false,
  },
  {
    path: paths.ssoRoute.apps.apps,
    component: Apps,
    key: "Apps",
    isPrivate: true,
  },
  {
    path: paths.ssoRoute.company.select_company,
    component: CompanyList,
    key: "Select Company",
    isPrivate: true,
  },
  {
    path: paths.client.users.company_users.company_user,
    component: CompanyUser,
    key: "CompanyUser",
    exact: true,
    // breadcrumb: "Users / Sub-Admins",
    isPrivate: true,
  },
  {
    path: paths.client.users.company_users.listing,
    component: CompanyUsers,
    key: "CompanyUsersList",
    exact: true,
    // breadcrumb: "Users / Sub-Admins",
    isPrivate: true,
  },
  {
    path: paths.client.users.company_users.create,
    component: CreateCompanyUser,
    key: "CompanyUserCreate",
    exact: true,
    breadcrumb: " Create Company User",
    isPrivate: true,
  },
  {
    path: paths.client.users.company_users.edit,
    component: CreateCompanyUser,
    key: "CompanyUserEdit",
    exact: true,
    breadcrumb: " Create Company User",
    isPrivate: true,
  },
  {
    path: paths.client.users.companies.edit,
    component: ClientCreateCompany,
    key: "Edit Company",
    exact: true,
    breadcrumb: "Users / Company Details / Create company",
    isPrivate: true,
    isCompany: true,
  },
  {
    path: paths.client.users.companies.listing,
    component: ClientCompanyProfile,
    key: "Companies Details",
    breadcrumb: "Users /  Company details",
    isPrivate: true,
    isCompany: true,
    //permission: permissions.VIEW_COMPANY_USER,
    routes: [
      {
        path: paths.client.users.companies.profile.details,
        component: ClientCompanyDetails,
        key: "Companies Details",
        exact: true,
        breadcrumb: "Users /  Company details",
        isPrivate: true,
        isCompany: true,
        // permission: permissions.VIEW_COMPANY_USER,
      },
      {
        path: paths.client.users.companies.profile.business_units.listing,
        component: ClientBusinessUnits,
        key: "Business Units",
        exact: true,
        breadcrumb: "Users / Business Units",
        isPrivate: true,
      },
      {
        path: paths.client.users.companies.profile.regions,
        component: ClientRegions,
        key: "Regions",
        exact: true,
        breadcrumb: "Users / Regions",
        isPrivate: true,
        isCompany: true,
      },
    ],
  },
  {
    path: paths.client.users.companies.profile.business_units.listing,
    component: ClientBusinessUnits,
    key: "Business Units",
    exact: true,
    breadcrumb: "Users / Business Units",
    isPrivate: true,
  },
  {
    path: paths.client.users.companies.profile.regions,
    component: ClientRegions,
    key: "Regions",
    exact: true,
    breadcrumb: "Users / Regions",
    isPrivate: true,
  },
  {
    path: "/",
    component: RedirectToApps,
    key: "Login",
    isPrivate: false,
  },
];
